import {post} from '@/utils/request';
import {erpserver,oaserver,erpplatserver} from '@/utils/baseUrl';

//
export async function queryPzList(params) {
    return post(erpserver+'/priceRecord/queryPzList', params, true);
}
//
export async function syncProductToYongyou(params) {
    return post(erpserver+'/priceRecord/syncProductToYongyou', params, true);
}
//挂牌提交作废
export async function updateListPriceState(params) {
    return post(erpserver+'/priceRecord/updateListPriceState', params, true);
}
//挂牌品种detail
export async function PzDetail(params) {
    return post(erpserver+'/priceRecord/queryListPricePzDetail', params, true);
}
//挂牌list
export async function list(params) {
    return post(erpserver+'/priceRecord/queryListPrice', params, true);
}
//保存
export async function saveListPrice(params) {
    return post(erpserver+'/priceRecord/saveListPrice', params, true);
}
//品种
export async function getpzlist(params) {
    return post(erpserver+'/priceRecord/queryAuthorizedPzListByKh', params, true);
}
//查询客户
export async function getkhlist(params) {
    return post(erpserver+'/priceRecord/queryKh', params, true);
}
// 获取公司
export async function getCompanyList(params) {
    return post(erpserver+'/currency/getCompanyList', params, true);
}
// 获取人
export async function getPersonList(params) {
    return post(oaserver+'/oacurrency/getPersonList', params, true);
}
// 获取部门 260121换成oaserver
export async function getGroupList(params) {
    return post(oaserver+'/oacurrency/getGroupList', params, true);
}


